<template>
  <div class="product-list">
    <div class="product-list__inner">
      <div class="product-list__list">
        <a
          v-for="product in productList"
          :key="product.id"
          :href="product.link"
          class="product-list__item"
          @mouseenter="selectedItem = product"
          @mouseleave="selectedItem = null"
        >
          <VIconMTS :name="`new-design/${product.icon}`" width="24" height="24" />
          <span>{{ product.title }}</span>
        </a>
      </div>
      <Transition name="fade">
        <p v-if="selectedItem?.description" class="product-list__description">
          {{ selectedItem?.description }}
        </p>
      </Transition>
    </div>
  </div>
</template>

<script>
import MainProductListMixin from '@/components/NewDesign/Page/Index/mixins/MainPromoProductListMixin'
import VIconMTS from '@/components/Common/MTS/VIconMTS.vue'
export default {
  name: 'MainPromoProductListDesktop',
  components: { VIconMTS },
  mixins: [MainProductListMixin],
  data() {
    return {
      selectedItem: null
    }
  }
}
</script>

<style scoped lang="scss">
.product-list {
  &__inner {
    position: relative;
  }

  &__list {
    display: grid;
    grid-template-columns: repeat(9, 1fr);
    min-height: 96px;
    padding: 4px;
    border-radius: 24px;
    border: 1px solid #bcc3d00d;
    font-family: $font-mts-compact;
    background-color: $color-white;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08),
    0 4px 24px 0 rgba(0, 0, 0, 0.12);
  }

  &__item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 5px;
    border-radius: 20px;
    font-size: 13px;
    line-height: 20px;
    color: $color-gray-1;
    text-decoration: none;
    transition: color .3s ease-out, background-color .3s ease-out;

    &:hover {
      color: $color-purple-2;
      background-color: $color-gray-2;
    }

    svg {
      fill: currentColor;
      transition: fill .3s ease-out;
    }
  }

  &__description {
    position: absolute;
    top: calc(100% + 16px);
    left: 0;
    right: 0;
    font-size: 14px;
    line-height: 20px;
    color: $color-gray-1;
    text-align: center;
  }
}

.fade {
  @include fade-transition(0.3s, ease-out)
}
</style>
